module.exports = __webpack_public_path__ + "img/97_4.4358964c.png";